module.exports = __webpack_public_path__ + "img/ico-edit-color.52ccb8fa.svg";